import Header from '../sections/Header.jsx'
import Hero from '../sections/Hero.jsx'
import Why from '../sections/Why.jsx'
import Platform from '../sections/Platform.jsx'
import Revenue from '../sections/Revenue.jsx'
import VnuMngr from '../sections/VnuMngr.jsx'
import MobileApp from '../sections/MobileApp.jsx'
import VenuePages from '../sections/VenuePages.jsx'
import Own from '../sections/Own.jsx'
import Compare from '../sections/Compare.jsx'
import How from '../sections/How.jsx'
import Faq from '../sections/Faq.jsx'
import Cta from '../sections/Cta.jsx'
import Footer from '../sections/Footer.jsx'
import { useSEO } from '@/hooks/useSEO'
import { site } from '../content.js'

export default function Home() {
  // Other pages set their own title/meta client-side; restore the home ones when coming back.
  useSEO({ title: site.title, description: site.description, url: site.url + '/' })
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VenuePages />
        <MobileApp />
        <Why />
        <Platform />
        <Revenue />
        <VnuMngr />
        <Own />
        <Compare />
        <How />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </>
  )
}
